<script>
import gql from 'graphql-tag'
import Breadcrumb from '@/components/shared/layout/Breadcrumb'
export default {
  name: 'baselayout',
  props: {
    header: { default: true },
    home: {required: false},
  },
  data () {
    return {
    }
  },
  components: {
    Breadcrumb,
  },
  apollo: {
    containers: {
      /*eslint-disable*/
      query: gql `query containers{
        containers{
          titre id
        }
      }`,
      fetchPolicy: 'cache-first',
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  methods: {
    goTo: function () {
      this.$router.push({name: 'hello'})
      // console.log(this.$refs.layout)
      // this.$refs.layout.hideCurrentSide()
      // this.$refs.layout.toggleLeft()
      /* console.log(this.$refs.layout)
      this.$refs.layout.hideCurrentSide()
      this.$refs.layout.toggleLeft()
      console.log(this.$refs.layout) */
    },
    getPath: function (id) {
      var temp = '/info/' + id
      return temp
    },
  },
  mounted () {
  },
}
</script>

<template lang="pug">
q-layout.layout(ref="layout", reveal, :left-breakpoint='4000')
  //- q-toolbar(slot='header', v-if='home', style='background: transparent !important')
  //-   q-btn.menubtn.fl(flat='', @click='$refs.layout.toggleLeft()')
  //-     i.fa.fa-bars.fa-2x.white
  .header(slot='header', v-if="header && !home")
    .toolbar.cf(style='background: none !important')
      q-btn.menubtndroite.fr(flat='', @click='$refs.layout.toggleLeft()')
        i.fa.fa-bars.fa-2x.white
        //- img.ma2(src="~@/assets/logo_DoaJC_transparent.png", width="70px")

      .breadcrumb
        breadcrumb.f6
  q-scroll-area(slot="left",style="width: 100%; height: 100%")
    i.fa.fa-close.fa-2x.white.fr.right-0.top-0.pa3.absolute.pointer(@click='$refs.layout.toggleLeft()')
    q-list-header.blocmenu.w-100.flex.justify-between.items-center
      div.enhaut.inset-shadow
        img.pt2.pointer(src="~@/assets/newlogos/logo_DOAJC_cropped.png", width="250px", @click='goTo()')
      div.aumilieu
        div.link.pt3
          q-side-link(to="/songs")
            h1 The songs
        div.link
          q-side-link(to="/story")
            h1 The story
        div.link
          q-side-link(to="/film")
            h1 The film
      div.enbas
        hr.white.w-50.mb3
        h2 Watch the documentary on CBC, december 7th 9PM ET
        hr.white.w-50.mt3.mb3
        div.socialicons.inline
          a.social-icon(target='_blank', href='https://www.facebook.com/pg/jewishxmasfilm')
            i.fa.fa-facebook.fa-2x.white.ph2
          a.social-icon(target='_blank', href='https://www.instagram.com/jewishxmasfilm/')
            i.fa.fa-instagram.fa-2x.white.ph2
          a.social-icon(target='_blank', href='https://twitter.com/jewishxmasfilm')

            i.fa.fa-twitter.fa-2x.white.ph2
        h3 RIDDLE FILMS INC. &copy; 2017
  slot
  //- q-carousel.text-white(slot='footer', v-if='!(home)', infinite='', autoplay='')
  //-   .sliderstyle(slot='slide')
  //-     div.images
  //-       img.pr3(src="~@/assets/373x100/cbc-cropped.png", width="85px;")
  //-       img.pr3(src="~@/assets/373x100/RSI-cropped.png", width="60px;")
  //-       img(src="~@/assets/373x100/ndr-cropped.png", width="50px;")
  //-
  //-   .sliderstyle(slot='slide')
  //-     div.images
  //-       img.pr3(src="~@/assets/373x100/svt-cropped.png", width="80px;")
  //-       img.pr3(src="~@/assets/373x100/NK-cropped.png", width="70px;")
  //-       img(src="~@/assets/373x100/yle-cropped.png", width="38px;")
  //-
  //-   .sliderstyle(slot='slide')
  //-     div.images
  //-       img.pr2(src="~@/assets/373x100/documentary-cropped.png", width="80px;")
  //-       img(src="~@/assets/373x100/rogers-cropped.png", width="100px;")
  //-
  //-   .sliderstyle(slot='slide')
  //-     div.images
  //-       img.pr2(src="~@/assets/373x100/cmf-cropped.png", width="145px;")
  //-       img(src="~@/assets/373x100/arte-cropped.png", width="50px;")

  //- q-toolbar(slot='footer', v-if='home', style="background-color: red !important")
  //-   div.flex-inline.pa3
  //-     img(src="~@/assets/373x100/cbc-cropped.png", width="70px;" height="100%")
  //-     img(src="~@/assets/373x100/RSI-cropped.png", width="40px;" height="100%")
  //-     img(src="~@/assets/373x100/ndr-cropped.png", width="50px;" height="100%")
  //-     img(src="~@/assets/373x100/svt-cropped.png", width="50px;" height="100%")
  //-     img(src="~@/assets/373x100/NK-cropped.png", width="70px;" height="100%")
  //-     img(src="~@/assets/373x100/yle-cropped.png", width="30px;" height="100%")
  //-     img(src="~@/assets/373x100/documentary-cropped.png", width="80px;" height="100%")
  //-     img(src="~@/assets/373x100/rogers-cropped.png", width="100px;" height="100%")
  //-     img.pr3.pt2(src="~@/assets/373x100/cmf-cropped.png", width="200px;" height="100%")
  //-     img(src="~@/assets/373x100/arte-cropped.png", width="60px;" height="100%")
</template>
<style>
/*.layout-page{
min-height:100%!important;
}*/
.modal-content{
	-webkit-box-shadow: none !important;
	-moz-box-shadow: none !important;
	box-shadow: none !important;
}
.modal-content::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}
.q-list-header{
  padding-left:0px !important;
}
.layout-header {
  border-bottom: 0px!important;
}
.layout-footer {
  border-top: 0px !important;
}
.layout-aside-left {
  left: 0;
  width: 100% !important;
}
.layout-aside-left.fixed {
  border-right: 0px!important;
}
.layout-aside-right {
  right: 0;
  width: 100% !important;
}
.layout-aside-right.fixed {
  border-left: 0px!important;
}
.blocmenu{

}
.sliderstyle{
  background-color:rgba(0,0,0,0.8);
  display:flex;
  justify-content: space-around;

}
.q-list-header{
  padding-left: 0px;
  width:100vw;
}
.q-btn{
  padding: 0 20px;
}
@media only screen and (min-width: 320px){
.blocmenu{
  height:100%;
  width:100%;
}
.sliderstyle{
  background-color:rgba(0,0,0,0.8);
  display:flex;
  justify-content: space-around;
  & .images{
    width:80%;
    padding-top:30px;
  }
}
.breadcrumb{
  position:absolute;
  padding: 11px 0 0 20px;
}
.layout-footer {
  border-top:0px;
}
.layout-aside{
   width: 100vw;
}
.enhaut{
  margin: 0 auto;
  width: 100%;
  background-image: url('~@/assets/newlogos/BKG-LAYERS-DJC_nologo.jpg');
  background-position:center;
  background-size: cover;
}
.aumilieu{
  margin: 0 auto;
  width: 100%;
  & .link{
    cursor: pointer;
  }
}
.enbas{
  margin: 0 auto;
  margin-bottom:11%;
  width:80%;
}
.menubtndroite{
  right: 0px !important;
  height: 50px !important;
  background-color: none;
}
.menubtngauche{
  left: 0px;
  height: 50px !important;
  background-color: none;
}
}
@media only screen and (min-width: 768px) and (max-width:960px){
  .layout-aside{
    width: 100vw;
  }
  .enhaut{
    margin: 0 auto;
  }
  .aumilieu{
    margin: 0 auto;
    & .link{
      cursor: pointer;
    }
  }
  .enbas{
    margin: 0 auto;
    width:80%;
  }
}
.layout {
  & .menubtn {
    height: 59px;
    position: absolute;
    float: right;
  }
  & .panelayout {
    height: 100vh;
  }
  & .toolbar {
    background-color: rgb(42, 42, 43);
  }
}
.layout-header{
  background: transparent !important;
  border-bottom: 0;
  padding-top:0;
  border-bottom-color: transparent !important;
}
.layout-page-container{
  padding-top: 0 !important;
}
.layout-aside{
  background: transparent !important;
  background-color:red !important;
  top: 0px !important;
  /*padding-top: 80px;*/
  width: 100%;
}
.layout-aside a{
  color:white;
}
.layout-aside h1{
  font-size: 26px;
  color: white;
  font-family: Abril Fatface;
  text-transform: uppercase;
  margin-bottom:10px;
}
.layout-aside h2{
  font-size: 23px;
  color: white;
  font-family: Barlow Condensed;
  line-height: 27px;
}
.layout-aside h3{
  font-size: 12px;
  color: white;
  font-family: MarketDeco;
  line-height: 20px;
}
.layout-aside p{
  font-size: 18px;
  color: white;
  line-height: 20px;
  margin-bottom:30px;
}

@media only screen and (min-width: 961px) and (orientation:landscape) {
  .layout-aside-left {
    left: 0;
    width: 375px !important;
  }
  .layout-page{
    min-height:100vh!important;
  }
  .layout-aside{
    width: 100vw;
  }
  .blocmenu{
    height:100%;
    /*width:50%;*/
  }
  .enhaut{
    margin: 0 auto;
  }
  .aumilieu{
    margin: 0 auto;
    & .link{
      cursor: pointer;
    }
  }
  .enbas{
    margin: 0 auto;
    width:80%;
  }
  .layout {
    & .menubtn {
      height: 59px;
      position: absolute;
      float: right;
    }
    & .panelayout {
      height: 100vh;
    }
    & .toolbar {
      background-color: rgb(42, 42, 43);
    }
  }
  .layout-header{
    background: transparent !important;
    border-bottom: 0;
    padding-top:0;
    border-bottom-color: transparent !important;
  }
  .layout-page-container{
    padding-top: 0 !important;
  }
  .layout-aside{
    background: transparent !important;
    background-color:red !important;
    top: 0px !important;
    /*padding-top: 80px;*/
    width: 100%;
  }
  .layout-aside a{
    color:white;
  }
  .layout-aside h1{
    font-size: 26px;
    color: white;
    font-family: MarketDeco;
    margin-bottom:10px;
  }
  .layout-aside h2{
    font-size: 16px;
    color: white;
    font-family: MarketDeco;
    line-height: 20px;
  }
  .layout-aside h3{
    font-size: 12px;
    color: white;
    font-family: MarketDeco;
    line-height: 20px;
  }
  .layout-aside p{
    font-size: 18px;
    color: white;
    line-height: 20px;
    margin-bottom:30px;
  }
}
</style>



// WEBPACK FOOTER //
// BaseLayout.vue?45ecb521